import {t} from "../../i18n";
import React, {useEffect, useState} from "react";
import {showCashier} from "../../payments/DepositActions";
import {useDispatch} from "react-redux";

export interface PaymentBroadcaseMessage {
    type: "payment" | "auth",
    status: "none" | "success" | "error",
    context?: any
}


export const OpenInNewWindow = (props: { url?: string, callback?: (msg: PaymentBroadcaseMessage) => void }) => {
    const dispatch = useDispatch();
    const [status, setStatus] = useState("none")

    let url = props.url;
    useEffect(()=>{
        const listener = (e : MessageEvent)  => {
            if (e.data) {
                const data = e.data as PaymentBroadcaseMessage

                if (data.type == "payment"  &&  (data.status == "success"  ||  data.status == "error")) {
                    setStatus(data.status)
                } else if (data.type == "auth"  &&  data.context.provider == "maya" ) {
                    setStatus(data.status)

                    if (props.callback) {
                        props.callback(data)
                    }
                }
            }

        };

        try {
            const channel = new BroadcastChannel('exit-payment');
            channel.addEventListener ('message', listener);

            return () => {
                channel.removeEventListener("message", listener);
            }
        } catch (e) {
            console.error("error creating listener")
        }

    },[])
    return (
        <div className={"open-in-new-window"}>
            {status == "none" && (
                <a className={"btn btn-cta large full-width"} href={url} target={"_blank"}>
                    {t("cashier.continue-in-new-window")}
                </a>
            )}
            {status == "success" && (
                <a className={"btn btn-cta large full-width"} onClick={()=>dispatch(showCashier(false))} target={"_blank"}>
                    {t("cashier.payment-success")}
                </a>
            )}
            {status == "error" && (
                <div className={"alert alert-danger"}>
                    {t("cashier.payment-error")}
                </div>
            )}
        </div>
    )
}